'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.singleton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LogService = require('./LogService.js');

var _LogService2 = _interopRequireDefault(_LogService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ls_instance = _LogService2.default.ls_instance;
var singleton = exports.singleton = Symbol.for('instance');
var singletonEnforcer = Symbol.for('enforcing');

var _serverTime = 0;
var _localTime = 0;
var _timeOffset = 0;
var _clientIP = "";
var _serviceURL = "";
var _ready = true;

var TimeService = function () {
	function TimeService(enforcer) {
		_classCallCheck(this, TimeService);

		if (enforcer !== singletonEnforcer) {
			throw new Error('Cannot construct a singleton');
		}
	}

	_createClass(TimeService, [{
		key: 'init',
		value: function init(serviceURL, callback) {
			global.fetch(serviceURL).then(function (response) {
				if (response.ok) {
					return response.json();
				}
				throw new Error('Network response was not ok.');
			}).then(function (response) {
				var timestamp = new Date(parseInt(response.datetime));
				if (timestamp.isValid() === true) {
					_serverTime = parseInt(response.datetime);
					_localTime = Math.round(new Date().getTime());
					_timeOffset = _serverTime - _localTime;
				}
				_clientIP = response.client_ip;
				_ready = true;
			}).catch(function (error) {
				console.error('[TimeService] init() There has been a problem with your fetch operation: ', error.message);
			}).finally(function () {
				callback(_clientIP);
			});
		}
	}, {
		key: 'getTimeOffset',
		value: function getTimeOffset() {
			return _timeOffset;
		}
	}, {
		key: 'getServerTime',
		value: function getServerTime() {
			return _serverTime;
		}
	}, {
		key: 'getClientIPAddress',
		value: function getClientIPAddress() {
			return _clientIP;
		}
	}, {
		key: 'isReady',
		value: function isReady() {
			return _ready;
		}
	}, {
		key: 'serviceURL',
		value: function serviceURL(url) {
			_serviceURL = url;
		}
	}], [{
		key: 'ts_instance',
		get: function get() {
			if (!TimeService[singleton]) {
				TimeService[singleton] = new TimeService(singletonEnforcer);
			}

			return TimeService[singleton];
		}
	}]);

	return TimeService;
}();

exports.default = TimeService;